import { createAction, props } from '@ngrx/store';

export const fullscreenChange = createAction('[Layout] Fullscreen Change', props<{ payload: boolean }>());
